import React from 'react'
import { createSvgIcon } from '../createSvgIcon'

export const Megaphone = createSvgIcon(
  <path d="M20.664 3.478L8 8v7l.748.267-1.127 2.254c-.26.519-.281 1.123-.06 1.659.223.536.665.949 1.216 1.133l4.084 1.361c.205.068.416.101.624.101.741 0 1.451-.414 1.797-1.104l1.303-2.606 4.079 1.457c.65.233 1.336-.25 1.336-.941V4.419C22 3.728 21.314 3.245 20.664 3.478zM13.493 19.777L9.41 18.416l1.235-2.471 4.042 1.444L13.493 19.777zM4 15h2V8H4c-1.103 0-2 .897-2 2v3C2 14.103 2.897 15 4 15z" />,
  'Megaphone',
  { viewBox: '0 0 24 24' }
)
